export default "__VITE_ASSET__9tBo5Rd2__"